export const recipientTypeOptions = [
  { label: "Contato do hóspede", value: "guest" },
  { label: "Outro contato", value: "other" },
]